import IconBase from './IconBase'
import { ReactComponent } from './light/smile.svg'

const Icon = (props: any) => <IconBase {...props} ReactComponent={ReactComponent} />

export default Icon
